import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaProtocolo = (): TabelaColuna => ({
  Chave: 'protocolo',
  Alinhamento: 'center',
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Protocolo</div>
})
